import ActionSet from './ActionSet'
import { LabelAPI } from '../api'
import { SnackBarActions } from '.'
import requestServiceConstantsMiddleware from '../middleware/requestServiceConstantsMiddleware'

export class LabelActionSet extends ActionSet{

  static initialState = {
    labels: [],
    requestingLabels: false
  }

  static constantsMiddleware = [
    requestServiceConstantsMiddleware
  ]

  static loadLabels(creator, reducer, constants){

    constants.defineRequestConstants()

    creator(() => {
      return dispatch =>
        dispatch({
          type: this.LOAD_LABELS,
          api: LabelAPI.index()
        })
    })

    reducer({
      [this.LOAD_LABELS_REQUEST]: (state) => {
        return {...state, requestingLabels: true}
      },
      [this.LOAD_LABELS_FAILURE]: (state) => {
        return {...state, requestingLabels: false}
      },
      [this.LOAD_LABELS_SUCCESS]: (state, { result: { body: { data: labels } } } ) => {
        return {...state, labels, requestingLabels: false }
      },
    })
  }

  static searchLabels(creator, reducer, constants){

    constants.defineRequestConstants()

    creator((query) => {
      return async dispatch => {
        const { body: { data : labels }} = await dispatch({
          type: this.SEARCH_LABELS,
          api: LabelAPI.search({...query})
        })
        return labels
      }
    })

    reducer({
      [this.SEARCH_LABELS_REQUEST]: (state) => {
        return {...state, requestingLabels: true}
      },
      [this.SEARCH_LABELS_FAILURE]: (state) => {
        return {...state, requestingLabels: false}
      },
      [this.SEARCH_LABELS_SUCCESS]: (state, { result: { body: { data: labels } } } ) => {
        return {...state, labels, requestingLabels: false }
      },
    })
  }
}

export default new LabelActionSet()